/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypereelhint3Inputs */

const en_crosspostingtypereelhint3 = /** @type {(inputs: Crosspostingtypereelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical video (9:16).`)
};

const de_crosspostingtypereelhint3 = /** @type {(inputs: Crosspostingtypereelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochformat-Video (9:16).`)
};

/**
* | output |
* | --- |
* | "Vertical video (9:16)." |
*
* @param {Crosspostingtypereelhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypereelhint3 = /** @type {((inputs?: Crosspostingtypereelhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypereelhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypereelhint3(inputs)
	return de_crosspostingtypereelhint3(inputs)
});
export { crosspostingtypereelhint3 as "crosspostingTypeReelHint" }